import Vue from 'vue';
import Vuex from 'vuex';

import { AuthStore, NoticeStore, pendoPlugin } from '@kasasa/fbase-components/lib';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		selectedNodeUid: "",
		expanded: true
	},
	mutations: {
	},
	actions: {
		setSelected(context, uid) {
			// yes, this should be a mutation
			context.state.selectedNodeUid = uid;
		},
		unsetSelected(context) {
			// yes, this should be a mutation
			context.state.selectedNodeUid = "";
		},
		setExpanded(context, payload) {
			context.state.expanded = payload;
		}
	},
	modules: {
		auth: AuthStore,
		notices: NoticeStore
	},
	plugins: [pendoPlugin]
});
